import { useTranslate } from "src/i18n";

export const useProductStorePickerTranslate = () => {
  const { t } = useTranslate();

  return {
    store: t("product_store.title", "Площадка"),
    all: t("product_store.all", "Все площадки"),
    all_from: (price: number, currency: string) =>
      t("product_store.all_from", "Все · от {price} {currency}", {
        price,
        currency,
      }),
  };
};
